(() => {
  const PRODUCT_SELECT_EVENT = 'shopify:product:select';

  class RestForwardProductQuestion extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.productSection = this.closest('.product-information');
      this.handleProductSelect = this.handleProductSelect.bind(this);

      this.productSection?.addEventListener(PRODUCT_SELECT_EVENT, this.handleProductSelect);
      this.updateHref(this.dataset.variantName || '');
    }

    disconnectedCallback() {
      this.productSection?.removeEventListener(PRODUCT_SELECT_EVENT, this.handleProductSelect);
    }

    async handleProductSelect(event) {
      if (!event.promise || !this.link) return;

      try {
        const result = await event.promise;
        const variant = result?.detail?.resource;
        if (variant) this.updateHref(variant.title || '');
      } catch (_error) {
        // Keep the initial product link usable if the theme's variant refresh fails.
      }
    }

    updateHref(variantTitle) {
      if (!this.link) return;

      const contactUrl = new URL(this.dataset.contactUrl || '/pages/contact', window.location.origin);
      contactUrl.searchParams.set('product', this.dataset.productName || '');

      const cleanVariant = variantTitle && variantTitle !== 'Default Title' ? variantTitle : '';
      if (cleanVariant) {
        contactUrl.searchParams.set('variant', cleanVariant);
      } else {
        contactUrl.searchParams.delete('variant');
      }

      if (this.dataset.productUrl) {
        contactUrl.searchParams.set('product_url', this.dataset.productUrl);
      }

      this.link.href = contactUrl.toString();
    }
  }

  if (!customElements.get('restforward-product-question')) {
    customElements.define('restforward-product-question', RestForwardProductQuestion);
  }

  const form = document.getElementById('RestForwardContactForm');
  if (!form) return;

  const params = new URLSearchParams(window.location.search);
  const productField = form.querySelector('#RestForwardContact-product');
  const productUrlField = form.querySelector('#RestForwardContact-product-url');
  const productName = params.get('product')?.trim();
  const variantName = params.get('variant')?.trim();

  if (productField && !productField.value && productName) {
    productField.value = [productName, variantName].filter(Boolean).join(' — ');
  }

  const productUrl = params.get('product_url');
  if (productUrlField && productUrl) {
    try {
      const safeUrl = new URL(productUrl, window.location.origin);
      if (safeUrl.origin === window.location.origin) productUrlField.value = safeUrl.href;
    } catch (_error) {
      // Ignore malformed context values; the visible product field remains editable.
    }
  }
})();
